import { Stack } from "@mui/material";
import { useRecordContext } from "react-admin";
import { EditableGrid, EditorField } from "@/components/common/EditableGrid";
import { ShowAccordionSection } from "@/components/common/ShowAccordionSection";
import { CodeDescriptionLine } from "@/components/common/fields/CodeDescriptionLine";
import { ClaimItem, ResourceName, CLAIM_TYPE_CHOICES } from "@/types";

export const ClaimItemServiceIdentification = () => {
  const record = useRecordContext<ClaimItem>();

  const claimItemFields: EditorField[] = [
    { source: "date_of_service", type: "date" },
    { source: "date_of_service_start", type: "date" },
    { source: "date_of_service_end", type: "date" },
    { source: "claim_type", type: "select", choices: CLAIM_TYPE_CHOICES },
    { source: "service_type" },
    { source: "procedure_code" },
    { source: "procedure_description" },
    { source: "primary_diagnosis" },
    { source: "diagnosis_description" },
  ];

  return (
    <ShowAccordionSection label="Service Identification" defaultExpanded>
      <EditableGrid fields={claimItemFields} recordType={ResourceName.CLAIM_ITEMS} />
      {/* Non-blocking ref-code enrichment — hidden entirely when codes or descriptions are absent. */}
      <Stack spacing={0.5} sx={{ mt: 1 }}>
        <CodeDescriptionLine label="Diagnosis" codeType="icd" code={record?.primary_diagnosis} />
        <CodeDescriptionLine label="Procedure" codeType="cpt" code={record?.procedure_code} />
      </Stack>
    </ShowAccordionSection>
  );
};
